import React, { useState } from "react";

// import contact data
import { contact } from "../../../../constants";
const Contact = () => {
  const [contactInfo, setContactInfo] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleContactFormSubmit = async (e) => {
    e.preventDefault();
    if (!contactInfo?.name) return;
    setContactInfo({
      name: "",
      email: "",
      subject: "",
      message: "",
    });
    e.target.reset();

    // console.log({ contactInfo });
    // const htmlForMail = getHTMLForMail({
    //   message: contactInfo?.message,
    //   name: contactInfo?.name,
    // });
    // await sendMail({
    //   receiverEmail: contactInfo?.email,
    //   subjectLine:
    //     contactInfo?.subject | "Contact form submitted from TechXNeuro Website",
    //   htmlBody: htmlForMail,
    // });
  };
  return (
    <section className="section bg-secondary" id="contact">
      <div className="container mx-auto">
        <div className="flex flex-col items-center text-center">
          <h2 className="section-title before:content-contact relative before:absolute before:opacity-40 before:-top-7 before:-left-40 before:hidden before:lg:block">
            Contact us
          </h2>
          <p className="subtitle">contact us</p>
        </div>
        <div className="flex flex-col lg:gap-x-8 lg:flex-row">
          <div className="flex flex-1 flex-col items-start space-y-8 mb-12 lg:mb-0 lg:pt-2">
            {contact.map((item, index) => {
              const {
                icon,
                title,
                subtitle,
                locations,
                description,
                phone,
                phone2,
              } = item;
              return (
                <div className="flex flex-col lg:flex-row gap-x-4" key={index}>
                  <div className="text-accent rounded-sm w-14 h-14 flex items-start justify-center mt-2 mb-4 lg:mb-0 text-2xl">
                    {icon}
                  </div>
                  <div>
                    <h4 className="font-body text-xl mb-1">{title}</h4>
                    <p className="mb-1 text-paragraph">{subtitle}</p>
                    {locations?.map((each, i) => {
                      return <p className="text-accent font-normal ">{each}</p>;
                    })}
                    <p className="text-accent font-normal ">{description}</p>
                    <p className="text-accent font-normal ">{phone2}</p>
                    <p className="text-accent font-normal ">{phone}</p>
                  </div>
                </div>
              );
            })}
          </div>
          <form
            className="space-y-8 w-full max-w-[780px]"
            onSubmit={(e) => handleContactFormSubmit(e)}
          >
            <div className="flex gap-8">
              <input
                className="input bg-tertiary"
                type="text"
                placeholder="Your name"
                onChange={(e) => {
                  setContactInfo((prev) => {
                    return { ...prev, name: e.target.value };
                  });
                }}
                required
              />
              <input
                className="input bg-tertiary"
                type="email"
                placeholder="Your email"
                onChange={(e) => {
                  setContactInfo((prev) => {
                    return { ...prev, email: e.target.value };
                  });
                }}
                required
              />
            </div>
            <input
              className="input bg-tertiary"
              type="text"
              placeholder="Subject"
              onChange={(e) => {
                setContactInfo((prev) => {
                  return { ...prev, subject: e.target.value };
                });
              }}
            />
            <textarea
              className="textarea bg-tertiary"
              placeholder="Your message"
              onChange={(e) => {
                setContactInfo((prev) => {
                  return { ...prev, message: e.target.value };
                });
              }}
            ></textarea>
            <button
              type="submit"
              className="btn btn-lg bg-accent hover:bg-secondary-hover"
            >
              Send message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
